<template>
  <div class="about-us">
    <section class="company-intro">
      <h1>公司介绍</h1>
      <p>
        洛洛崽宠物公司是一家专注于高品质宠物服务的综合平台，致力于为全国宠物爱好者提供一站式解决方案。我们的业务范围涵盖宠物购买、饲养指导、健康护理等多个方面，旨在打造一个安全、便捷、专业的宠物交流与交易平台。
      </p>
      <h1>核心优势</h1>
      <ul>
        <li>
          <strong>严格审核：</strong
          >我们对所有入驻商家进行严格的资质审核，确保每一家店铺都具备合法经营资格和良好的信誉记录。
        </li>
        <li>
          <strong>100%实拍：</strong
          >平台上展示的所有宠物图片均为真实拍摄，拒绝虚假宣传，让客户能够直观地了解宠物的真实情况。
        </li>
        <li>
          <strong>担保交易：</strong
          >采用先进的担保交易系统，保障买家的资金安全，直到宠物顺利交接后才会将款项支付给卖家。
        </li>
        <li>
          <strong>宠物拍卖：</strong
          >独特的宠物拍卖服务，通过公开竞价的方式，为买家提供公平竞争的机会，同时也为卖家带来更高的收益潜力。
        </li>
        <li>
          <strong>137模式：</strong
          >独特的“137”售后服务模式，即在宠物交付后的1天内可无理由退货，3天内可更换同品种宠物，7天内享受免费健康检查服务。
        </li>
        <li>
          <strong>多样化选择：</strong
          >提供猫猫、狗狗、异宠等多种类别的宠物，满足不同客户的需求。
        </li>
        <li>
          <strong>专业团队：</strong
          >拥有一支经验丰富且充满爱心的专业团队，他们不仅精通宠物饲养知识，还擅长解决各种宠物健康问题。
        </li>
      </ul>
      <h1>服务内容</h1>
      <ul>
        <li>
          <strong>宠物购买：</strong>
          提供各类高品质宠物，包括但不限于猫咪、狗狗及异宠等。
        </li>
        <li>
          <strong>饲养指导：</strong
          >通过线上课程和一对一咨询服务，帮助新主人快速掌握宠物饲养技巧。
        </li>
        <li>
          <strong>健康护理：</strong
          >与多家知名宠物医院合作，为客户提供全面的宠物健康检查和治疗方案。
        </li>
        <li>
          <strong>社区互动：</strong
          >搭建了一个活跃的宠物社区，用户可以在这里分享经验、交流心得，并参与各种有趣的活动。
        </li>
      </ul>
      <p><strong>我们的承诺</strong></p>
      <p>
        洛洛崽宠物公司始终坚持以客户为中心的服务理念，不断优化产品和服务质量，努力成为您最信赖的宠物伙伴。无论您是初次养宠的新手还是资深宠物爱好者，我们都将竭诚为您提供最优质的服务体验。
      </p>

      <p>
        如果您有任何疑问或需要进一步的帮助，请随时联系我们的客服团队。感谢您选择洛洛崽宠物公司，让我们一起开启美好的宠物生活旅程！
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
.about-us {
  width: 60%;
  margin: 0 auto;
}

.company-intro {
  line-height: 1.6;
}

.company-intro h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.company-intro p {
  margin-bottom: 10px;
}

.company-intro ul {
  list-style-type: none;
  padding-left: 0;
}

.company-intro li {
  margin-bottom: 5px;
}
</style>
